export const ON_FETCH = 'on_fetch';
export const on_UPDATE = 'on_update';

export default (state, action) => {
  switch (action.type) {
    case ON_FETCH:
      return {
        ...state,
        data: action.payload,
      };

    default:
      return state;
  }
};
